import { render, staticRenderFns } from "./BDR2026Dictionary.vue?vue&type=template&id=5647854b&"
import script from "./BDR2026Dictionary.vue?vue&type=script&lang=js&"
export * from "./BDR2026Dictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports